import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import assistanceApi from "../../api/assistance";
import { selectAssistanceAddressList } from ".";
import { IFilterType } from "../filterType";
import { CancelToken } from "axios";
import {
  listEffectCountFilter,
  listEffectGetFilter,
  listEffectLoad,
  listEffectReload,
  listEffectsCountCheck,
  listEffectsGetCheck,
  listEffectsGetCount,
  listEffectsGetNew,
  listEffectsGetParams,
} from "../listEffect";

export function getAssistanceAddressList(
  assistanceId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectAssistanceAddressList(getState());
    if (listEffectsGetCheck(state.state)) {
      return;
    }

    let newState = listEffectsGetNew(state);
    dispatch(actions.assistanceAddressListFetchRequest(newState.newCountState));
    try {
      const params = listEffectsGetParams(state, newState.take);
      listEffectGetFilter(params, state.filter);

      const addresses = await assistanceApi.getAddressList(assistanceId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();
      newState = listEffectsGetCount(newState, addresses);

      dispatch(
        actions.assistanceAddressListFetchSuccess({
          data: addresses.data,
          newCountState: newState.newCountState,
          newCount: newState.newCount,
        })
      );
    } catch {
      dispatch(
        actions.assistanceAddressListFetchError(
          cancelToken.reason !== undefined
        )
      );
    }
  };
}

export function getAssistanceAddressListCount(
  assistanceId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectAssistanceAddressList(getState());
    if (listEffectsCountCheck(state.countState)) {
      return;
    }

    dispatch(actions.assistanceAddressListCountRequest());
    try {
      const params = listEffectCountFilter(state.filter);
      const count = await assistanceApi.getAddressCount(assistanceId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();

      dispatch(actions.assistanceAddressListCountSuccess(count.data));
    } catch {
      dispatch(
        actions.assistanceAddressListCountError(
          cancelToken.reason !== undefined
        )
      );
    }
  };
}

export function changeAssistanceAddressListOrder(
  orderBy: string,
  orderDesc: boolean
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.assistanceAddressListChangeOrder({ orderBy, orderDesc }));
  };
}

export function changeAssistanceAddressListPage(page: number): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.assistanceAddressListChangePage(page));
  };
}

export function changeAssistanceAddressListFilter(
  filter: IFilterType
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.assistanceAddressListChangeFilter(filter));
  };
}

export function assistanceAddressListLoad(reload: boolean): AppThunkAction {
  return async (dispatch, getState) => {
    const state = selectAssistanceAddressList(getState());
    reload = listEffectReload(reload, state);
    if (reload) {
      dispatch(actions.assistanceAddressListReset());
    } else {
      const newState = listEffectLoad(state);
      dispatch(
        actions.assistanceAddressListLoadAction({
          newState: newState.newState,
          newCountState: newState.newCountState,
        })
      );
    }
  };
}
